"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeBuilderItem = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Add_1 = __importDefault(require("@material-ui/icons/Add"));
const Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const ArrowRight_1 = __importDefault(require("@material-ui/icons/ArrowRight"));
const HourglassEmpty_1 = __importDefault(require("@material-ui/icons/HourglassEmpty"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const Badge_1 = __importDefault(require("@material-ui/core/Badge"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tree_styles_1 = require("./tree-styles");
function TreeBuilderItem({ data: { download, nestingLevel, id, node }, isOpen, style, setOpen, treeData, }) {
    var _a, _b, _c;
    const [isLoading, setLoading] = react_1.useState(false);
    const downloaded = ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) === ((_b = node.value) === null || _b === void 0 ? void 0 : _b.childrenCount);
    const isLeaf = ((_c = node.value) === null || _c === void 0 ? void 0 : _c.childrenCount) === 0;
    const label = node.value.label;
    const version = node.value.version;
    const { addNode, updateNode } = treeData;
    const classes = tree_styles_1.useStyles();
    const handleOpen = event_callback_hook_1.useEventCallback(async (e) => {
        if (isLeaf) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (!downloaded) {
            setLoading(true);
            await (download === null || download === void 0 ? void 0 : download(id));
            await setOpen(!isOpen);
            setLoading(false);
        }
        else {
            await setOpen(!isOpen);
        }
    });
    const handleAddNode = event_callback_hook_1.useEventCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        addNode({ id, label, childrenCount: 0 });
    });
    const handleUpdateNode = event_callback_hook_1.useEventCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        updateNode({ id, label, version });
    });
    return (react_1.default.createElement(ListItem_1.default, { button: true, style: style, classes: {
            root: classes.item,
        }, onClick: handleOpen },
        !isLeaf && (react_1.default.createElement("div", null,
            react_1.default.createElement(Button_1.default, { size: "small", className: classes.collapseButton, variant: "contained", component: "label", disableElevation: true }, isLoading ? (react_1.default.createElement(HourglassEmpty_1.default, { fontSize: "small" })) : isOpen ? (react_1.default.createElement(ArrowDropDown_1.default, { fontSize: "small" })) : (react_1.default.createElement(ArrowRight_1.default, { fontSize: "small" }))))),
        react_1.default.createElement("div", { className: classes.itemBody, style: {
                marginLeft: nestingLevel * 26 + (isLeaf ? 40 : 0),
            } },
            react_1.default.createElement(Button_1.default, { size: "small", className: classes.actionButton, variant: "contained", component: "label", disableElevation: true, onClick: handleAddNode },
                react_1.default.createElement(Add_1.default, { fontSize: "small" })),
            react_1.default.createElement(Button_1.default, { size: "small", className: classes.actionButton, variant: "contained", component: "label", disableElevation: true, onClick: handleUpdateNode },
                react_1.default.createElement(Edit_1.default, { fontSize: "small" })),
            react_1.default.createElement("div", null,
                label,
                react_1.default.createElement(Badge_1.default, { anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    }, classes: {
                        root: classes.itemBadgeRoot,
                        badge: classes.itemBadgeContent,
                    }, badgeContent: node.value.childrenCount, color: "primary" })))));
}
exports.TreeBuilderItem = TreeBuilderItem;
//# sourceMappingURL=tree-builder-item.js.map